class Header {
  constructor() {
    this.el = document.getElementById("jsHeader");
    this.timer = 100;
    this.timeout = null;
    this.className = "sticky";
    this.top = 95;
    this.Init();
    this.Scroll();
  }

  Init() {
    if (window.innerWidth < 1200) {
      this.top = 60;
    }
    if (this.el) {
      if (window.scrollY >= this.top) {
        this.el.classList.add(this.className);
      } else {
        this.el.classList.remove(this.className);
      }
    }
  }

  Scroll() {
    window.addEventListener("scroll", () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.Init(), this.timer);
    });
  }
}

window.addEventListener("load", () => {
  let header = new Header();
});